module.exports = __webpack_public_path__ + "img/review_banner.7488808a.png";